import { render, staticRenderFns } from "./r-close-button.vue?vue&type=template&id=b504975a&scoped=true"
var script = {}
import style0 from "./r-close-button.vue?vue&type=style&index=0&id=b504975a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504975a",
  null
  
)

export default component.exports